module.exports = __webpack_public_path__ + "img/pdf-pipeline.a79ecca6.png";